<template>
  <div
    class="table-cell action-cell"
    :class="`${name} ${group.isCustomUserRow && 'border-transparent'}`"
  >
    <button
      v-if="!group.isCustomUserRow && name === 'add-row'"
      :disabled="addRowGroupIsOtherGroup"
      class="btn btn-sm d-flex justify-content-center py-1 px-1"
      @click="() => onClickActionCell(group)"
    >
      <i
        v-if="group.name === addRowGroup"
        class="bi-x p-0"
        :class="`${addRowGroupIsOtherGroup && 'text-muted'}`"
      >
      </i>
      <i
        v-else
        class="bi-plus p-0"
        :class="`${addRowGroupIsOtherGroup && 'text-muted'}`"
      >
      </i>
    </button>
    <button
      v-if="name === 'remove-row'"
      class="btn btn-sm d-flex justify-content-center py-1 px-1"
      @click="() => onClickActionCell(group)"
    >
      <i class="bi-x p-0" :class="`${addRowGroupIsOtherGroup && 'text-muted'}`">
      </i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PulsTableRowActionCell',
  props: {
    group: {
      type: Object,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    onClickActionCell: {
      type: Function,
      required: true
    },
    addRowGroup: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      addRow: false
    }
  },
  computed: {
    addRowGroupIsSameAsGroup() {
      return this.addRowGroup && this.addRowGroup === this.group.name
    },
    addRowGroupIsOtherGroup() {
      return this.addRowGroup && this.addRowGroup !== this.group.name
    }
  },
  methods: {
    toggleAddRow() {
      this.addRow = !this.addRow
    }
  }
}
</script>

<style lang="scss">
.table-cell-title-arrow {
  transition: transform 0.2s ease;
  &.rotated {
    transform: rotate(90deg);
  }
}
</style>
